module.exports = __webpack_public_path__ + "static/media/greenhouse2Step10-3.51df80f1.jpg";